[
    {
        "display": "true",
        "ui_columnname": "Action",
        "db_columnname": "modifiedFlag",
        "datatype": "char",
        "mappingkey": "modifiedFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "maxlength": 1,
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "CustomerID",
        "db_columnname": "CustomerID",
        "datatype": "String",
        "mappingkey": "CustomerID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "maxlength": 40,
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "ReceivedFromMPID",
        "db_columnname": "ReceivedFromMPID",
        "datatype": "String",
        "mappingkey": "ReceivedFromMPID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "maxlength": 4,
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AffiliateFlag",
        "db_columnname": "AffiliateFlag",
        "datatype": "String",
        "mappingkey": "AffiliateFlag",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "dropdown": "YES",
        "maxlength": 1,
        "dropdowntype": "singleSelect",
        "dropdownvalue": [
            { "label": "Y", "value": "Y", "description": "True" },
            { "label": "N", "value": "N", "description": "False" }]
        },
    {
        "display": "true",
        "ui_columnname": "Created Date",
        "db_columnname": "createdDate",
        "datatype": "Date",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated Date",
        "db_columnname": "updatedDate",
        "datatype": "Date",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created User",
        "db_columnname": "createdUser",
        "datatype": "String",
        "mappingkey": "createdUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated User",
        "db_columnname": "updatedUser",
        "datatype": "String",
        "mappingkey": "updatedUser",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": true,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }
]